import RUF from "../../../util/redux";

export function downPaymentAmountSave(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      downPayment: RUF.updateObject(state.model.downPayment, {
        amount: action.payload
      })
    })
  });
}
